export default __webpack_public_path__ + "static/media/view_grid_enable.49fa068f.svg";